import React, { useEffect, useState } from "react";
import { baseUrl, apiToken } from "../../utils/base_url";
import { Link } from "react-router-dom";
import moment from "moment";
import { Breadcrumb } from "antd";
import { Button } from "../Button/Button";
import axios from "axios";
import categorieIcon from "../../assets/image/categorieIcon.png";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _450px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import BlogCard from "../Blog/BlogCard";
import PractitionersCarousel from "../Carousel/PractitionersCarousel";
import { fetchPageData } from "../../endpoint/pageApi";

const BlogListing = ({ data, isMobile, setPageSize, pageSize, total }) => {
  const [categories, setCategories] = useState([]);
  const [selectedSlug, setSeletedSlug] = useState(null);
  const [loader, setLoader] = useState(false);
  const [blogsData, setBlogsData] = useState(data);
  const [popularBlogs, setPopularBlogs] = useState([]);
  const [favoriteBlogs, setFavoriteBlogs] = useState([]);
  const [carouselData, setCarouselData] = useState();

  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  useEffect(() => {
    fetchPageData(
      `blogs-banners?populate=about_header.cover_media`,
      setCarouselData,
      setLoader,
      true
    );
  }, []);

  // useEffect(() => {
  // const fetchCategories = async () => {
  //   try {
  //     const res = await axios.get(`${baseUrl}/api/blog-categories`, {
  //       headers: {
  //         Authorization: `Bearer ${apiToken}`,
  //       },
  //     });
  //     setCategorie(res?.data?.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // fetchCategories();

  //   fetchPageData("blog-categories", setCategories, setLoader, false, true);

  //   const filterPopularBlogs = data?.filter((blog) => blog.is_popular === true);
  //   setPopularBlogs(filterPopularBlogs);

  //   const filterFavBlogs = data?.filter((blog) => blog.is_favorite === true);
  //   setFavoriteBlogs(filterFavBlogs);
  // }, []);

  // const handleFindCategorie = (slug) => {
  //   const filteredBlogs = data?.filter((blog) =>
  //     blog.blog_categories?.some((category) => category.slug === slug)
  //   );
  //   setBlogsData(filteredBlogs);
  // };
  // const handleCategoryClick = (slug) => {
  //   setSeletedSlug(slug);
  //   handleFindCategorie(slug);
  // };

  // const handleCardsClear = () => {
  //   setSeletedSlug(null);
  //   setBlogsData(data);
  // };

  console.log("ABt", carouselData);

  return (
    <div
      className="m-0 pt-0 py-5"
      style={{
        backgroundColor: " #090D24",
        color: "#fff",
        fontFamily: "Nunito Sans",
      }}
    >
      <div className="container px-0 pb-md-5 pt-3 contwidth">
        {/* <div className="row">
          <div className="col-12 px-0">
            {favoriteBlogs?.map((item, index) => (
              <React.Fragment key={index}>
                <Link
                  to={`/blogs/${item?.slug}`}
                  className="text-decoration-none"
                >
                  <div
                    className={`rounded-4  ${isMobile ? "mx-4" : "mx-2"}`}
                    style={{
                      backgroundImage: `url(${baseUrl}${item?.thumbnail?.url})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      objectFit: "cover",
                      height: isMobile ? "auto" : _1500?"370px":_1600?"350px":_1800?"350px":"477px",
                    }}
                  >
                    <div
                      className="d-flex flex-column justify-content-end rounded-4 h-100 w-100"
                      style={{
                        background: "rgba(21, 26, 78, 0.7)",
                        padding: "20px",
                      }}
                    >
                      <p
                        className={`text-white fw800 lh-sm`}
                        style={{
                          paddingRight:_576?"":_1700?"5rem":"10rem",
                          fontSize: _576
                            ? "20px"
                            : _768
                            ? "25px"
                            : _992
                            ? "30px"
                            : _1200
                            ? "35px"
                            : _1400
                            ? "35px"
                            : _1600
                            ? "40px"
                            : _1700
                            ? "50px"
                            : _1800
                            ? "50px"
                            : "60px",
                        }}
                      >
                        {item?.heading}
                      </p>
                      <p
                        className={`text-start text-white fw500 lh-sm`}
                        style={{
                          fontSize: _576
                            ? "15px"
                            : _768
                            ? "15px"
                            : _992
                            ? "15px"
                            : _1200
                            ? "20px"
                            : _1400
                            ? "20px"
                            : _1600
                            ? "25px"
                            : _1700
                            ? "25px"
                            : _1800
                            ? "30px"
                            : "30px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: item?.excerpt,
                        }}
                      >
                      </p>
                    </div>
                  </div>
                </Link>
              </React.Fragment>
            ))}
          </div>
        </div> */}

        {/* <h3 className="mt-4">Latest Posts</h3> */}
        <div className="row mb-4 pt-3">
          <div className="col-12">
            <PractitionersCarousel data={carouselData?.blogs?.[0]} />
          </div>
          {/* {popularBlogs?.map((item, index) => {
            return <BlogCard key={index} item={item} />;
          })} */}
          {/* 
          <div className="col-12 my-5">
            <div
              className={`d-flex justify-content-between ${
                isMobile ? "px-4" : "px-0"
              }`}
            >
              <div
                style={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  width: "75%",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
                className="align-self-center"
              >
                {categories?.map((cate, index) => {
                  const isSelected = selectedSlug === cate?.slug;
                  return (
                    <>
                      <Button
                        key={index}
                        background={isSelected ? "#fff" : " #0039EC"}
                        textColor={isSelected ? "#0039EC" : " #fff"}
                        newButtonClassName={`${
                          isMobile ? "fs14 px-4" : "fs20 px-5"
                        }  py-2 fw600 rounded border-0 d-flex flex-row gap-3`}
                        onClick={() => {
                          handleCategoryClick(cate?.slug);
                        }}
                      >
                        {cate?.name}
                      </Button>
                    </>
                  );
                })}
              </div>
              <div className="align-self-start">
                <img src={categorieIcon} />
              </div>
            </div>
          </div> */}

          {/* {selectedSlug ? (
            <div className="col-12">
              <div className="d-flex justify-content-end">
                <Button
                  background={"#0039EC"}
                  textColor={"white"}
                  newButtonClassName={
                    "fs-14 px-5 py-2 mx-3 fw-semibold rounded border-0"
                  }
                  onClick={handleCardsClear}
                >
                  Clear All
                </Button>
              </div>
            </div>
          ) : (
            " "
          )} */}

          <div className="col-12 my-3">
            <div className="row">
              {blogsData?.map((item, index) => (
                <BlogCard key={index} item={item} />
              ))}
            </div>
          </div>

          {/* <div className="d-flex align-items-center justify-content-center">
            <Button
              children={"Load More"}
              className={"rounded-3 px-5 fs20 fw800"}
              background={"#0039EC"}
              textColor=" #FFFFFF"
              width={_768 ? "" : "32%"}
              onClick={}
            />
          </div> */}
          {total >= pageSize && (
            <div className="d-flex align-items-center justify-content-center">
              <Button
                children="Load More"
                className="rounded-3 px-5 fs20 fw800"
                background="#0039EC"
                textColor="#FFFFFF"
                width={_768 ? "" : "32%"}
                onClick={() => setPageSize(pageSize + 9)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogListing;
